import styled from "styled-components";
import { variants, paddingBottoms, fontWeights, linkVariants, defaults } from "./options";
import { COLORS, TYPOGRAPHY } from "../../globals/designSystem";
import { mq } from "../../globals/utils";

export const StyledDisplay1 = styled.h1`
  ${TYPOGRAPHY.display_1}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || "500"};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 56px;
  }
  ${mq.below.md} {
    font-size: 40px;
  }
`;

export const StyledDisplay2 = styled.h1`
  ${TYPOGRAPHY.display_2}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  ${mq.between("md", "lg")} {
    font-size: 40px;
  }
  ${mq.below.md} {
    font-size: 32px;
  }
`;

export const StyledDisplay2Xs = styled.h1`
  ${TYPOGRAPHY.display_2_xs}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  ${mq.between("md", "lg")} {
    font-size: 30px;
  }
  ${mq.below.md} {
    font-size: 24px;
  }
`;

export const StyledDisplay3 = styled.h1`
  ${TYPOGRAPHY.display_3}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || "600"};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 32px;
  }
  ${mq.below.md} {
    font-size: 24px;
  }
`;

export const StyledTitleNew1 = styled.h1`
  ${TYPOGRAPHY.title_new_1}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || "500"};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 32px;
  }
  ${mq.below.md} {
    font-size: 24px;
  }
`;

export const StyledTitleNew2 = styled.h1`
  ${TYPOGRAPHY.title_new_2}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || "500"};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 28px;
  }
  ${mq.below.md} {
    font-size: 20px;
  }
`;

export const StyledTitleNew3 = styled.h1`
  ${TYPOGRAPHY.title_new_3}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 24px;
  }
  ${mq.below.md} {
    font-size: 20px;
  }
`;

export const StyledTitleNew4 = styled.h1`
  ${TYPOGRAPHY.title_new_4}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 22px;
  }
  ${mq.below.md} {
    font-size: 20px;
  }
`;

export const StyledQuote1 = styled.h1`
  ${TYPOGRAPHY.quote_1}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || 300};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("lg", "xl")} {
    font-size: 30px;
  }
  ${mq.between("md", "lg")} {
    font-size: 26px;
  }
  ${mq.below.md} {
    font-size: 24px;
  }
`;

export const StyledQuote2 = styled.h1`
  ${TYPOGRAPHY.quote_2}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 24px;
  }
  ${mq.below.md} {
    font-size: 20px;
  }
`;

export const StyledLead = styled.h1`
  ${TYPOGRAPHY.lead}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 24px;
  }
  ${mq.below.md} {
    font-size: 20px;
  }
`;

export const StyledLabel1 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.label_1}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  a {
    color: #2c64f4;
    &:hover {
      color: #2c64f4;
      .arrow {
        transform: translate(5px, 2px);
      }
    }
    .arrow {
      display: inline-block !important;
      margin-left: 6px;
      transform: translate(0px, 2px);
      transition: all 0.3s ease-in-out;
    }
  }
  ${mq.between("md", "lg")} {
    font-size: 16px;
  }
  ${mq.below.md} {
    font-size: 14px;
  }
`;

export const StyledBody1 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.body_1}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  a {
    color: ${({ linkVariant }) => linkVariants[linkVariant]?.color || defaults.linkVariant.color};
    &:hover,
    &:focus {
      color: ${({ linkVariant }) =>
        linkVariants[linkVariant]?.hoverColor || defaults.linkVariant.hoverColor};
    }
  }
  ${mq.between("md", "lg")} {
    font-size: 18px;
  }
  ${mq.below.md} {
    font-size: 16px;
  }
`;

export const StyledBody2 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.body_2}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  .leftIcon {
    margin-right: 8px;
  }
  .rightIcon {
    margin-left: 8px;
  }
  .displayFlexCenter {
    display: flex;
    align-items: center;
  }
  .arrow {
    transition: all 0.3s ease-in-out;
  }
  a {
    color: ${({ linkVariant }) => linkVariants[linkVariant]?.color || defaults.linkVariant.color};
    &:hover,
    &:focus {
      color: ${({ linkVariant }) =>
        linkVariants[linkVariant]?.hoverColor || defaults.linkVariant.hoverColor};
      .arrow {
        transform: translateX(5px);
      }
    }
  }
  ${mq.between("md", "lg")} {
    font-size: 16px;
  }
  ${mq.below.md} {
    font-size: 14px;
  }
`;

export const StyledBody3 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.body_3}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 14px;
  }
  ${mq.below.md} {
    font-size: 14px;
  }
`;

export const StyledTitle1B = styled.h1`
  ${TYPOGRAPHY.title_1b}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 42px;
  }
  ${mq.below.md} {
    font-size: 36px;
  }
`;

export const StyledTitle2 = styled.h1`
  ${TYPOGRAPHY.title_2}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 42px;
  }
  ${mq.below.md} {
    font-size: 36px;
  }
`;

export const StyledTitle2B = styled.h1`
  ${TYPOGRAPHY.title_2b}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || 600};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 38px;
  }
  ${mq.below.md} {
    font-size: 32px;
  }
`;
export const StyledTitle3B = styled.h1`
  ${TYPOGRAPHY.title_3b}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || 600};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 36px;
  }
  ${mq.below.md} {
    font-size: 32px;
  }
`;

export const StyledTitle3 = styled.h1`
  ${TYPOGRAPHY.title_3}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 36px;
  }
  ${mq.below.md} {
    font-size: 24px;
  }
`;

export const StyledTitle4 = styled.h2`
  ${TYPOGRAPHY.title_4}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 30px;
  }
  ${mq.below.md} {
    font-size: 26px;
  }
`;

export const StyledSubTitle1 = styled.h4`
  ${TYPOGRAPHY.subtitle_1}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || 600};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 24px;
  }
  ${mq.below.md} {
    font-size: 22px;
  }
`;

export const StyledSubTitle1Light = styled.h4`
  ${TYPOGRAPHY.subtitle_1_light}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 24px;
  }
  ${mq.below.md} {
    font-size: 22px;
  }
`;

export const StyledSubTitle2 = styled.h4`
  ${TYPOGRAPHY.subtitle_2}
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]?.fontWeight || "500"};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  .leftIcon {
    margin-right: 12px;
    width: 24px;
  }
  ${mq.between("md", "lg")} {
    font-size: 20px;
  }
  ${mq.below.md} {
    font-size: 20px;
  }
`;

export const StyledDesc1 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.description_1}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  h1 {
    ${TYPOGRAPHY.description_1}
    color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
    font-weight: ${({ fontWeight }) =>
      fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  }
  .discUl {
    padding-inline-start: 20px;
    .disc {
      display: list-item;
      list-style-type: disc;
    }
  }
  .leftIcon {
    margin-right: 12px;
    width: 24px;
  }
  .rightIcon {
    margin-left: 12px;
    width: 24px;
  }
  .sm {
    width: 18px;
  }
  .arrow {
    display: inline-block !important;
    margin-left: 6px;
    transition: all 0.3s ease-in-out;
  }
  .flexCenter {
    display: flex;
    align-items: center;
  }
  a {
    color: ${({ linkVariant }) => linkVariants[linkVariant]?.color || defaults.linkVariant.color};
    &:hover,
    &:focus {
      color: ${({ linkVariant }) =>
        linkVariants[linkVariant]?.hoverColor || defaults.linkVariant.hoverColor};
      .arrow {
        transform: translateX(5px);
      }
    }
    .arrow {
      display: inline-block !important;
      margin-left: 6px;
      transition: all 0.3s ease-in-out;
    }
  }
  ${mq.between("md", "lg")} {
    font-size: 16px;
  }
  ${mq.below.md} {
    font-size: 16px;
  }
`;

export const StyledDescCode18 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.description_code_18}
  text-transform: uppercase;
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  ${mq.between("md", "lg")} {
    font-size: 16px;
  }
  ${mq.below.md} {
    font-size: 16px;
  }
`;

export const StyledDescCode16 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.description_2_mono}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
`;

export const StyledDescCode14 = styled.div`
  margin: 0 0;
  ${TYPOGRAPHY.description_code_14}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
`;

export const StyledDesc2 = styled.div`
  border-bottom: ${props => props?.borderBottom || ""};
  text-align: ${props => props?.textAlign || ""};
  padding-left: ${props => props?.paddingLeft || ""};
  margin: 0 0;
  ${TYPOGRAPHY.description_2}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  .discUl {
    padding-inline-start: 20px;
    .disc {
      display: list-item;
      list-style-type: disc;
    }
  }
  .leftIcon {
    margin-right: 12px;
    min-width: 16px;
    width: 16px;
  }
  .rightIcon {
    margin-left: 12px;
    min-width: 16px;
    width: 16px;
  }
  .md {
    min-width: 24px;
    width: 24px;
  }
  .arrow,
  .arrowInline {
    display: inline-block;
    margin-left: 6px;
    transition: all 0.3s ease-in-out;
  }
  .displayFlex {
    display: flex;
    align-items: center;
  }
  a {
    color: ${({ linkVariant }) => linkVariants[linkVariant]?.color || defaults.linkVariant.color};
    &:hover,
    &:focus {
      color: ${({ linkVariant }) =>
        linkVariants[linkVariant]?.hoverColor || defaults.linkVariant.hoverColor};
      .arrow,
      .arrowInline {
        transform: translateX(5px);
      }
    }
    .arrow {
      display: inline-block;
      margin-left: 2px;
      transition: all 0.3s ease-in-out;
    }
    .arrowInline {
      margin-left: 6px;
    }
  }
  ${mq.below.md} {
    font-size: 16px;
  }
`;

export const StyledDesc3 = styled.div`
  ${TYPOGRAPHY.description_3}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  margin: 0 0;
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  a {
    color: ${({ linkVariant }) => linkVariants[linkVariant]?.color || defaults.linkVariant.color};
    &:hover,
    &:focus {
      color: ${({ linkVariant }) =>
        linkVariants[linkVariant]?.hoverColor || defaults.linkVariant.hoverColor};
    }
  }
  .discUl {
    padding-inline-start: 20px;
    .disc {
      display: list-item;
      list-style-type: disc;
    }
  }
  .leftIcon {
    margin-right: 12px;
    min-width: 16px;
    width: 16px;
  }
  .md {
    min-width: 24px;
    width: 24px;
  }
  .rightIcon {
    margin-left: 8px;
    min-width: 16px;
    width: 16px;
  }
  .arrow {
    display: inline-block;
    margin-left: 6px;
    transition: all 0.3s ease-in-out;
  }
  .rotate180 {
    transform: rotate(180deg);
  }
  .egc-coc {
    min-width: 24px;
    margin-right: 0px;
  }
  .displayFlexCenter {
    display: flex;
    align-items: center;
  }
  a {
    &:hover {
      .arrow {
        transform: translateX(5px);
      }
    }
  }
  ${mq.below.md} {
    font-size: 14px;
  }
`;

export const StyledDescTag = styled.div`
  ${TYPOGRAPHY.description_tag}
  font-weight: ${({ fontWeight }) =>
    fontWeights[fontWeight]?.fontWeight || defaults.fontWeight.fontWeight};
  margin: 0 0;
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottoms[paddingBottom]?.paddingBottom || defaults.paddingBottom.paddingBottom};
  .leftIcon {
    margin-right: 6px;
  }
  a {
    color: ${({ linkVariant }) => linkVariants[linkVariant]?.color || defaults.linkVariant.color};
    &:hover {
      color: ${({ linkVariant }) =>
        linkVariants[linkVariant]?.hoverColor || defaults.linkVariant.hoverColor};
    }
  }
`;
export const StyledFooterTitle = styled.div`
  ${TYPOGRAPHY.footer_title}
  color: ${({ variant }) => variants[variant]?.color || defaults.variant.color};
  padding: 10px 24px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  ${mq.below.md} {
    padding: 10px 20px;
  }
`;
export const StyledTableTitle = styled.div`
  margin: 0 0;
  font-family: "IBM Plex Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.5;
  /* color: ${({ variant }) => variants[variant]?.color || defaults.variant.color}; */
  color: #111927;
  padding: 0 16px;
  /* text-transform: uppercase; */
  ${mq.between("md", "lg")} {
    font-size: 16px;
  }
  ${mq.below.md} {
    font-size: 14px;
  }
`;

export const StyledTogglePricingNavItem = styled.div`
  margin: 0 0;
  font-family: "IBM Plex Sans";
  font-style: normal;
  width: 124px;
  /* padding: 8px 16px; */
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  color: #6c737f;
  letter-spacing: 0.005em;
  /* border-radius: 12px; */
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #111b29;
  }

  &.toggleNavItemActive {
    color: ${COLORS.sky_0};
    transition: all 0.3s ease-in-out;
    &:hover {
      color: ${COLORS.sky_0};
    }
  }
  ${mq.below.md} {
    width: 50%;
  }
`;

export const StyledToggleNavItem = styled.div`
  margin: 0 0;
  font-family: "IBM Plex Sans";
  font-style: normal;
  width: 172px;
  padding: 8px;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  line-height: 150%;
  color: ${COLORS.grey_80};
  border-radius: 2px;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  &:hover {
    color: #111b29;
  }
  &.toggleNavItemActive {
    color: ${COLORS.sky_0};
    transition: all 0.3s ease-in-out;
    &:hover {
      color: ${COLORS.sky_0};
    }
  }
  ${mq.below.md} {
    width: 50%;
  }
`;
